import styled from 'styled-components';

/** One turn: a panel of its own, so where one turn ends and the next begins is plain. */
export const Turn = styled.section`
  border: 1px solid var(--line);
  border-radius: 12px;
  background: rgba(0, 0, 0, .18);
  overflow: hidden;

  & + & {
    margin-top: 12px;
  }
`;

/** A turn's header band: which turn, and whose. */
export const TurnTitle = styled.h3`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin: 0;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--text, #f4f1e8);
  background: rgba(255, 255, 255, .08);
  border-bottom: 1px solid var(--line);
`;

/** Whose turn it was, at the right of the band. */
export const TurnPlayer = styled.span`
  color: var(--muted);
  font-weight: 600;
`;

/** The log's own heading on a wide screen, above the turns. */
export const LogHeading = styled.h2`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 8px;
`;

/** One move: its sentences together, a line between moves. */
export const Move = styled.ul`
  list-style: none;
  margin: 0;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.4;

  & + & {
    border-top: 1px solid var(--line);
  }
`;

/** A small button in the game's top bar, styled like the view switch beside it. */
export const LogButton = styled.button`
  border: 0;
  border-radius: 9px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: rgba(255, 255, 255, .08);
  color: var(--muted);
`;

/** The log in the game's side panel on a wide screen: under the hand, using the rest of the panel's height. */
export const InlineLogArea = styled.section`
  padding: 8px 12px 16px;
  border-top: 1px solid var(--line);
  margin-top: 4px;
`;

/** When a move was made, above its sentences. */
export const MoveTime = styled.li`
  font-size: 11px;
  color: var(--muted);
  margin-bottom: 2px;
`;

/** One sentence of the log, with the cards it's about in front of it. */
export const Line = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;

  & + & {
    margin-top: 4px;
  }
`;

export const Cards = styled.span`
  display: flex;
  flex: none;
  align-items: center;
  gap: 3px;
  --card-w: 30px;
`;
